import Vue from "vue";
import store from "./store/index.js";
import router from "./router/index.js";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import VueApexCharts from 'vue-apexcharts';

Vue.component('apexchart', VueApexCharts);

import App from "./App.vue";

Vue.use(ElementUI, { locale });

new Vue({
  el: '#app',
  components: {
    apexchart: VueApexCharts,
  },
  store,
  router,
  render: h => h(App),
});
